import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { API_BASE_URL } from '../../models/api-base-url.token';

export const baseUrlInterceptor: HttpInterceptorFn = (req, next) => {
  const base = inject(API_BASE_URL);
  if (!/^https?:\/\//i.test(req.url)) {
    const url = `${base.replace(/\/+$/, '')}/${req.url.replace(/^\/+/, '')}`;
    req = req.clone({ url });
  }
  return next(req);
};
